import React from 'react'
import { Checkbox, withStyles } from '@material-ui/core'

const CustomsCheckbox = withStyles((theme) => ({
  root: {
    '&.MuiCheckbox-root:not(.Mui-disabled) > span.MuiIconButton-label': {
      color: 'currentcolor',
    },
    '&.MuiCheckbox-root': {
      color: theme.colors['grey-100'] + '!important',
    },
    '&.Mui-checked': {
      color: theme.colors['primary'] + '!important',
    },
    '&.MuiCheckbox-indeterminate': {
      color: theme.colors['primary'] + '!important',
    },
    '&.Mui-disabled': {
      color: theme.colors['grey-200'] + '!important',
    },
  },
}))(Checkbox)

const CheckBox = (prop) => {
  return <CustomsCheckbox {...prop} />
}

export default CheckBox
